<div class="topDiv" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv">
        <div *ngIf="refresh" class="row topRowMargins headerStyle" style="
        margin-right: 0;
        margin-left: 0;
        margin-top: 3%;
        
        ">
        <label i18n="@@spmsUserReg" class="textColour">Objects</label>
        <span class="example-spacer"></span>
        <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="getRouterLink(link)"
              [queryParams]="getQueryParams(link.label)"
              [active]="link.label === 'Objects'"
              style="min-width:130px; opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
      </div>
<div>

    <mat-toolbar class="agGridtoperDiv card" style="
            background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
    border-right: 1px solid #a9a9a9a8;
    border-left: 1px solid #a9a9a9a8;"
    
    > 


                <label i18n="@@spmsUserReg"*ngIf ="!refresh" class="textColour">{{headerNameHtml}}</label>

                <button
                *ngIf="selectedRows.length > 0 && columnsOfAction"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"  [style.background-color]="backgroundColorButton"
                title="Copy Selected Objects to Target" id="130"
                (click)="submitSelectedRows()"[disabled]="!hasPermissionToAccessButton(130)">
                Copy
                <em style="padding: 0px 0px 0px 10px;" class="fas fa-copy" title="Copy Selected Objects to Target"></em>
              </button>
              <!-- <input  type="file" #fileInput  style="display: none;" (change)="excelFileUpload($event)"> -->
              <button 
              *ngIf="refresh && !(selectedRows.length > 0 && columnsOfAction)"
               class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                       [style.background-color]="backgroundColorButton"
                       title="Upload File" id="108"
                       (click)="excelFileUploadForObjects()"[disabled]="!hasPermissionToAccessButton(108)">
                 Upload File
     <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
     </button>
                         

                <!-- <label i18n="@@spmsUserReg" class="textColour">{{headerNameHtml}}</label> -->

                <!-- <div *ngIf="file" style=" margin-left: 15%;"> -->
                    <!-- <span class="example-spacer"></span> -->
     <!-- <input type="file" #fileInput  style="display: none;" (change)="onFileChange($event)"> -->
     <!-- Upload File Button -->
     <!-- <button  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                       [style.background-color]="backgroundColorButton"
                       title="Upload File"
                       (click)="excelFileUploadForObjects()">
                 Upload File
     <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
     </button> -->
                <!-- </div> -->
                         
              <!-- <input type="file" #fileInput  style="display: none;" (change)="onFileChange($event)"> -->
              <!-- Upload File Button -->
              <!-- <button *ngIf="uploadFile" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                [style.background-color]="backgroundColorButton"
                                title="Upload File"
                                (click)="excelFileUploadForObjects()">
                          Upload File
              <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
              </button> -->
                         

                          <div *ngIf="refresh">
                            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left: 10px;width: 90px;" [style.background-color]="backgroundColorButton" title="Refresh All" (click) = "startVaultObjectChnagesDetection()" id="131" >Refresh All<em style="padding: 0px 0px 0px 10px;" class="fas fa-sync-alt" title="Refresh All"></em></button>
                            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left: 5px; width: 120px;" [style.background-color]="backgroundColorButton" title="Refresh History" (click) = "openRefreshHistory('Refresh History')" id="132" >Refresh History<em style="padding: 0px 0px 0px 10px;" class="fas fa-history" title="Refresh History"></em></button>
                            <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left: 5px; width: 120px;" [style.background-color]="backgroundColorButton" title="Detect Changes" (click) = "startVaultObjectChnagesDetection()" >Detect Changes<em style="padding: 0px 0px 0px 10px;" class="fas fa-search" title="Detect Changes"></em></button>
                            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="margin-left: 5px; width: 110px;" [style.background-color]="backgroundColorButton" title="View Changes" (click) = "openDetectedChanges('View Changes')" >View Changes<em style="padding: 0px 0px 0px 10px;" class="fas fa-eye" title="View Changes"></em></button> -->
                            <div class="selectRecordsDiv" style="display: inline-block;">
                        <!-- **************************
                         *@ModifiedBy: Shyam
                         @Date : 08-02-2025
                         @Note added dropsown of dns to show particular objects based on selected dns
                         ********************     -->
                                <mat-form-field appearance="outline" style="width: 100%;">
                                    <mat-label i18n="@@Targetstdcode" style="color:black">Select DNS</mat-label>
                                    <mat-select [ngModelOptions]="{standalone:true}" [(ngModel)]="name" (ngModelChange)="selectDns($event)">
                                        <mat-option style="font-size: 15px;" *ngFor="let eachdns of dnsnames" [value]="eachdns.name" [disabled]="isEnabled">
                                            {{eachdns.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        
                           <span  class="navigate-icon">  <i class="material-icons" (click)="navigateToTarget()" title="Go to Stage Object">arrow_forward</i></span>
                        </div>
                         <span class="example-spacer"></span>
                         <div *ngIf="headerNameHtml=='Key Phrases Catalog'">
                            <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refreshRun()">
                                Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                            </button>
                            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download Template File" (click)="downloadfilefromS3(s3Path)">TemplateFile
                                <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                            </button>
                            </div> 
                            
                            <!-- ========================================================== -->

                            <button *ngIf="headerNameHtml === 'Import Export MetaData'"
                                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                style="margin-left: 5px; width: 160px;" [style.background-color]="backgroundColorButton"
                                title="Import/Export" (click)="openImportExportCentralized()">Import/Export <em
                                    style="padding: 0px 0px 0px 10px;" class="fas fa-exchange-alt" title="Import/Export"></em></button>

                                                        <button *ngIf="headerNameHtml === 'Import Export MetaData'"  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                                            style="margin-left: 5px; width: 160px;" [style.background-color]="backgroundColorButton" title="Import Export History"
                                                            (click)="openRefreshHistory('Import Export History')">Import Export History<em style="padding: 0px 0px 0px 10px;"
                                                                class="fas fa-history" title="Import Export History"></em></button>

                            
                            <button *ngIf="headerNameHtml === 'Load Objects' || headerNameHtml === 'Objects' || headerNameHtml === 'Source Data Extraction Queries' || headerNameHtml === 'Company' || headerNameHtml === 'User Registration'||  headerNameHtml === 'Data Source Configuration' ||  headerNameHtml === 'User Roles' ||  headerNameHtml === 'Manage Workspace'"
 class="popup gridColour btn btn-rounded-button z-depth-1
                                    waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" [style.min-width.px]="100"
                                style="font-size: 12px; padding: 4px 10px; height: 32px;"id="102" title="Import Data" (click)="importData()">
                                Import
                                <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
                            </button>
                            <!-- Import Button -->
                            <button *ngIf="headerNameHtml === 'Load Objects' || headerNameHtml === 'Objects' || headerNameHtml === 'Source Data Extraction Queries' ||  headerNameHtml === 'Company' ||  headerNameHtml === 'User Registration' ||  headerNameHtml === 'Data Source Configuration' ||  headerNameHtml === 'User Roles' ||  headerNameHtml === 'Manage Workspace'"
class="popup gridColour btn btn-rounded-button z-depth-1
                                                           waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                                [style.min-width.px]="100" style="font-size: 12px; padding: 4px 10px; height: 32px;"id="103" title="Export Data"
                                (click)="exportData()">
                                Export
                                <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
                            </button>
                            
                            <!-- ================================================ -->

                             <button *ngIf="uploadFile || file" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                [style.background-color]="backgroundColorButton"
                                title="Upload File" id="108"
                                (click)="excelFileUploadForObjects()">
                             Upload File
                            <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
                             </button>
                         <button *ngIf= "tableName !== 'loginauditmstr' && tableName !== 'exceptionsmstr'" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Add Record" (click) = "openSaveForm('Save')" [disabled]="isdisable" id="114">Add Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>
           
                        </button>
                        <button *ngIf="headerNameHtml != 'Objects'" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                                <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div  *ngIf="headerNameHtml != 'Objects'&& headerNameHtml != 'Source Data Extraction Queries'" class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                        (click)="onBtPrevious()"></em></li>
                                <li>{{currentPage}}/{{totalPages}}</li>
                                <li class="paginationliicon" style="padding:0;"><em
                                        class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>

            </mat-toolbar>

    
</div>
<div *ngIf="agGridShow && headerNameHtml === 'JSuite Properties'"
    style="display: flex; width: 100%;">
    <div style="flex: 0 0 17%; padding-right: 8px;">
        <ag-grid-angular class="ag-theme-balham tablestyles square scroolbar-dusty-grass square thin"
            style="width: 100%; height: 100%; font-size: 14px;" [rowData]="categoriesList" [columnDefs]="columnDefsCategory"
            [defaultColDef]="defaultColDef" [headerHeight]="50" [rowHeight]="35" [animateRows]="true"
            [enableBrowserTooltips]="true" [suppressPaginationPanel]="true" [pagination]="false" [rowSelection]="'single'"
            [enableRangeSelection]="false" (gridReady)="onCategoryGridReady($event)"
            (rowClicked)="onCategoryRowClicked($event)">
        </ag-grid-angular>
        </div>
        <div *ngIf="agGridShow" style="flex: 1;">
        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true"
        [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
        [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
        (paginationChanged)="onPaginationChanged()" [components]="components"
        (gridReady)="onGridReady($event)"  [hidden]="!true"></ag-grid-angular>

        </div>
    </div>
    <div *ngIf="agGridShow && headerNameHtml != 'JSuite Properties'">
    
        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
            [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection"
            [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35"
            [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
            [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
            [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
            [components]="components" (gridReady)="onGridReady($event)"
            [hidden]="!true"></ag-grid-angular>
    
    </div>

</div>
</div>
